import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Injectable } from "@angular/core";
import { SecurityService } from "./security.service";
import { ConfigurationService } from "./configuration.service";
import { Observable, observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { IIdentityUser } from "../models/identity-user.model";
import { Roles } from "../models/roles.model";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private securityService: SecurityService,
    private configurationService: ConfigurationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (window.location.hash) {
      const path = window.location.pathname;
      this.securityService.AuthorizedCallback();
      this.securityService.authenticationChallenge$.subscribe(() => {
        this.router.navigate([path]);
      });
    }
    if (this.configurationService.isReady) {
      return this.Authorize(route, state);
    } else {
      return this.configurationService.settingsLoaded$.pipe(
        map(() => this.Authorize(route, state))
      );
    }
  }

  private Authorize(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let isAuthorized =
      this.securityService.IsAuthorized &&
      !this.securityService.isTokenExpired();
    const byPassAuth =
      this.configurationService.serverSettings.byPassAuth === "True";
    if (byPassAuth) {
      return byPassAuth;
    }
    if (isAuthorized) {
      const user = this.securityService.UserData;
      isAuthorized = this.AuthorizeRole(route, state, user);
    } else {
      this.securityService.Authorize();
    }
    return isAuthorized;
  }

  private AuthorizeRole(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    user: IIdentityUser
  ): boolean {
    if (
      state.url === "/" ||
      (route.data.roles && route.data.roles.indexOf(user.role) === -1)
    ) {
      this.RedirectRole(user.role);
      return false;
    }
    return true;
  }

  private RedirectRole(role: string) {
    if (role === Roles.Administrator) {
      this.router.navigate(["/admin"]);
    } else if (role === Roles.Developer) {
      this.router.navigate(["/developer"]);
    } else if (role === Roles.Network) {
      window.location.href = `${this.configurationService.serverSettings.spWebUrl}/Network/Search`;
    }
  }
}
